import React, { useState, useEffect } from "react";
import useStyles from "./styles";
import api from "../../../Axios/api";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import MaterialTable from "material-table";
import { Link } from "react-router-dom";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
import { useUserContext } from "../../../context/UserContext";
import noImage from "../../../assets/images/Product Images/noImage.png";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

// MUI Components
import { Grid, Typography, Avatar, Paper, Button } from "@material-ui/core";
import pal from "../../../themes/palette";
import {
  Subscriptions,
  SubscriptionsRounded,
  SubscriptionsSharp,
  Unsubscribe,
  UnsubscribeOutlined,
} from "@material-ui/icons";

export default function SubscribedStores() {
  const { store } = useUserContext();
  const token = store.data.token;
  const classes = useStyles();
  const [details, setDetails] = useState([]);
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const columns = [
    {
      title: "Id#",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
    },
    {
      title: "Logo",
      field: "Logo",
      render: ({ logo }) => (
        <img
          src={logo != null ? logo : noImage}
          alt="Profile Pic"
          style={{ width: 40, height: 40, borderRadius: "50%" }}
        />
      ),
    },
    {
      title: "Store Name",
      field: "name",
      width: 150,
    },

    {
      title: "Seller Name",
      field: "sellerName",
      width: 150,
    },
    {
      title: "City",
      field: "city",
      width: 150,
    },
    {
      title: "Category",
      field: "category",
      width: 150,
    },
    {
      title: "Actions",
      render: ({ _id }) => (
        <Button
          color="primary"
          variant="contained"
          onClick={() => unSubsribeStore(_id)}
        >
          {" "}
          <UnsubscribeOutlined style={{ marginRight: 4 }} />
          Un-Subscribe
        </Button>
      ),
    },
  ];
  const retrivingAllSubscribers = async () => {
    await api
      .get("/buyer/stores/subscribed", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log(res.data.data);
        setDetails(res.data.data.subscribedStores);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  const unSubsribeStore = async (id) => {
    await api
      .patch(`/buyer/store/Unsubscribe`,{storeId: id}, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // console.log(res.data.data);
        let temp = details;
        temp = temp.filter((review) => {
          return review._id != id;
        });
        setDetails(temp);
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "UnSubscribed to Store successfully.",
          open: true,
        });
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  useEffect(() => {
    //scroll to the top of page
    window.scrollTo(0, 0);
    // Retriving List of Subscribers from API
    retrivingAllSubscribers();
  }, []);

  return (
    <div>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>
      <div className={classes.mainAboutusContainer}>
        <Breadcrumbs
          style={{ paddingTop: 30, paddingBottom: 20 }}
          aria-label="breadcrumb"
        >
          <Link className={classes.bCrumbLink} style={{ color: "grey" }} to="/">
            Home
          </Link>
          <Link
            className={classes.bCrumbLink}
            style={{ color: "grey" }}
            to="/account"
          >
            My Account
          </Link>
          <Typography color="textPrimary">Subscribed Stores </Typography>
        </Breadcrumbs>
        <div>
          <Grid container spacing={1} style={{ margin: "0px 0px 30px 0px" }}>
            <Grid item xs={12} sm={12} md={12} component={Paper}>
              <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                  <LibraryAddIcon />
                </Avatar>
                <Typography variant="h5" style={{ marginBottom: 20 }}>
                  Subscribed Stores
                </Typography>
                <MaterialTable
                  style={{ width: "100%" }}
                  title="All Subscribers"
                  data={details}
                  columns={columns}
                  // actions={[
                  //   (rowData) => ({
                  //     icon: () => <EditIcon />,
                  //     tooltip: "Edit",
                  //     onClick: (event, rowData) => {
                  //       setBuyerDetails(rowData);
                  //       handleOpen();
                  //     },
                  //   }),
                  // ]}
                  options={{
                    actionsColumnIndex: -1,
                    headerStyle: {
                      backgroundColor: pal.palette.primary.main,
                      color: "#fff",
                      whiteSpace: "nowrap",
                    },

                    // tableLayout: "auto",
                    pagination: "false",
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} component={Paper}></Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}
